import { Radio, Tv, Newspaper, Globe2, Mic2, Music4, Video, Palette, PenLine, Film } from "lucide-react";
import Footer from "@/components/Footer";
import { Link } from "react-router-dom";

const GROUPS = [
  {
    title: "Promozione 360°",
    caption: "Per artisti e aziende",
    items: [
      { icon: Radio, label: "Radio", d: "Airplay, ospitate, lanci in FM e digital broadcast." },
      { icon: Tv, label: "TV", d: "Ospitate, palinsesti locali e nazionali, collaborazioni." },
      { icon: Newspaper, label: "Stampa", d: "Ufficio stampa, comunicati, reviewer e magazine." },
      { icon: Globe2, label: "Web & Social", d: "Campagne digital, influencer, DSP e piattaforme." },
    ],
  },
  {
    title: "Produzione creativa",
    caption: "Contenuti chiavi in mano",
    items: [
      { icon: Mic2, label: "Spot & Jingle", d: "Voce, musica, mix. Radio, TV e web-ready." },
      { icon: Video, label: "Videoclip", d: "Regia, riprese, post produzione, colore." },
      { icon: Palette, label: "Grafica", d: "Cover, artwork, identità visiva, campagne." },
      { icon: Music4, label: "Musiche & canzoni", d: "Composizione, arrangiamenti, produzione discografica." },
      { icon: PenLine, label: "Testi & sceneggiature", d: "Copy, storytelling, script, treatment." },
      { icon: Film, label: "Format Radio & TV", d: "Concept, pilot, sviluppo, produzione esecutiva." },
    ],
  },
];

export default function Services() {
  return (
    <div className="pt-28 pb-16">
      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <span className="av-eyebrow">Servizi NMA</span>
        <h1 className="font-serif-display text-4xl sm:text-6xl mt-3 leading-tight">
          Non solo palco: <span className="italic text-[#E5A93C]">amplifichiamo</span>
          <br className="hidden sm:block" /> tutto il resto.
        </h1>
        <p className="text-[#F7F4EE]/80 max-w-2xl mt-6 leading-relaxed">
          Da 30 anni NMA Agency accompagna artisti, brand e enti anche fuori dal palco:
          promozione integrata su radio, TV, stampa e web, e produzione creativa dal
          jingle al videoclip, dalla grafica alla sceneggiatura. Un unico interlocutore,
          voci selezionate, uno studio produttivo interno.
        </p>

        {GROUPS.map((g) => (
          <div key={g.title} className="mt-16" data-testid={`services-group-${g.title.split(" ")[0].toLowerCase()}`}>
            <div className="flex flex-wrap items-end justify-between gap-3">
              <h2 className="font-serif-display text-3xl">
                {g.title}
              </h2>
              <span className="text-xs text-[#A39E93] uppercase tracking-widest">
                {g.caption}
              </span>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-6">
              {g.items.map((it) => (
                <div key={it.label} className="av-card p-6" data-testid={`service-${it.label.split(" ")[0].toLowerCase()}`}>
                  <it.icon size={22} className="text-[#E5A93C]" />
                  <h3 className="font-serif-display text-xl mt-3">{it.label}</h3>
                  <p className="text-sm text-[#A39E93] mt-2 leading-relaxed">{it.d}</p>
                </div>
              ))}
            </div>
          </div>
        ))}

        <div className="av-card p-8 mt-20 flex flex-wrap items-center justify-between gap-4">
          <div>
            <div className="av-eyebrow">Vuoi lavorare con noi?</div>
            <h3 className="font-serif-display text-2xl mt-2">
              Raccontaci il progetto. <span className="italic text-[#E5A93C]">Ti richiamiamo.</span>
            </h3>
          </div>
          <Link to="/richiedi" className="av-pill av-pill-gold" data-testid="services-cta">
            Parla con NMA
          </Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
